import * as angular from 'angular';


export class AncillariesSpecialMealsTransformer {
    constructor (
        private $filter: ng.IFilterService,
        private AncillariesConstants: AncillariesConstant
    ) {}

    generateSegmentSpecialMeal = (specialMealsInfo: any, cachedData: any) => {
        const slices: any = cachedData.order.slices;
        const allSegments = {};
        let specialMealSegments = [];
        for (let i = 0; i < slices.length; i++) {
            for (let j = 0; j < slices[i].segments.length; j++) {
                allSegments[slices[i].segments[j].id] = {
                    departure: slices[i].segments[j].departure,
                    arrival: slices[i].segments[j].arrival,
                    departureDateParsed: this.$filter<any>('DateFormatFilter')(slices[i].segments[j].departureDateTime, 'shortDate'),
                    arrivalDateParsed: this.$filter<any>('DateFormatFilter')(slices[i].segments[j].arrivalDateTime, 'shortDate'),
                    cabin: slices[i].segments[j].cabin
                };
            }
        }
        if (specialMealsInfo.segments) {
            specialMealSegments = specialMealsInfo.segments;

            angular.forEach(specialMealSegments, (segment) => {
                segment.segmentInfo = allSegments[segment.id];
            });

        }
        return specialMealSegments;
    };

    generatePassengersInfoSpecialMeals = (cachedData: any) => {
        const pasInfo = [];
        angular.forEach(cachedData.passengers, (pas) => {
            pasInfo.push({
                id: pas.passengerId,
                name: pas.externalPersonalInfo ? pas.externalPersonalInfo.name : pas.personalInfo.name,
                surname: pas.externalPersonalInfo ? pas.externalPersonalInfo.firstSurname + ' ' + pas.externalPersonalInfo.lastSurname : pas.personalInfo.surname,
                infant: pas.passengerType === this.AncillariesConstants.TYPE_PASSENGER.INFANT,
                relatedPassengerId: pas.relatedPassengerId
            });
        });

        return pasInfo;
    };

    generateMealsPreSelected = (cachedData: any) => {
        const pasInfo = [];
        angular.forEach(cachedData.order.orderItems, (orderItem) => {
            if (orderItem.type === this.AncillariesConstants.TYPES.MEAL) {
                pasInfo.push(orderItem);
            }
        });
        return pasInfo;
    };

    generateNumSelectSpecial = (specialMeal: any) => {
        let contSpecialMeal = 0, w;
        for (w = 0; w < specialMeal.length; w++) {
            if (specialMeal[w].type === this.AncillariesConstants.TYPES.MEAL && specialMeal[w].serviceCode !== 'standard') {
                contSpecialMeal++;
            }
        }
        return contSpecialMeal;
    };
}

AncillariesSpecialMealsTransformer.$inject = ['$filter', 'AncillariesConstants'];
try {
    const mod = angular.module('ib-web-ancillaries-module');
    mod.service('AncillariesSpecialMealsTransformer', AncillariesSpecialMealsTransformer);
} catch (error) {
    const mod = angular.module('ib-web-ancillaries-module', []);
    mod.service('AncillariesSpecialMealsTransformer', AncillariesSpecialMealsTransformer);
}
